import { render, staticRenderFns } from "./PchTaxDocumentPending.vue?vue&type=template&id=46f962dc&lang=pug&"
import script from "./PchTaxDocumentPending.vue?vue&type=script&lang=js&"
export * from "./PchTaxDocumentPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PchTaxDocumentPending.vue"
export default component.exports